export default __webpack_public_path__ + "static/media/Karishma_2021-04-05.db4fd55e.docx";